var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter1Design1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 125,
    viewBox: "0 0 220 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.143 108.352L213.611 70.5414L220 81.523L173.682 108.352L220 135.099L213.611 146.163L148.143 108.352ZM129.092 141.527L194.379 179.337L187.99 190.319L141.886 163.736V216.852H129.092V141.527ZM129.092 75.2924V0H141.87V53.3294L187.974 26.5825L194.363 37.564L129.092 75.2924ZM90.842 141.527V216.852H78.048V163.671L31.9437 190.253L25.555 179.272L90.842 141.527ZM90.842 75.2924L25.555 37.564L31.9437 26.5825L78.048 53.3294V0H90.8255L90.842 75.2924ZM12.5964 157.128L96.8685 108.582L12.5964 59.8723L18.9851 48.7264L103.619 97.6007V0H116.381V97.4363L200.834 48.7264L207.223 59.7079L122.407 108.582L207.223 157.292L200.834 168.274L116.381 119.745V217H103.619V119.564L18.9851 168.274L12.5964 157.128ZM71.6758 108.352L6.38873 146.163L0 135.181L46.3019 108.352L0 81.6709L6.38873 70.6894L71.6758 108.352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1Design1);
export default __webpack_public_path__ + "static/media/footer_1_design_1.a2ef924fbd03ada301b0784e4e362db1.svg";
export { ForwardRef as ReactComponent };